import { PostDetail } from 'types/PostDetail';
import { isDocumentAttachmentCard } from 'utils/attachments';

export const getPostAttachmentCount = (
  cards: PostDetail['attachments']['cards'],
) => {
  const counts = {
    videos: 0,
    images: 0,
    documents: 0,
  };

  const mediums = cards.map((card) => card.medium);

  const videos = mediums.filter((attachment) => attachment?.type === 'video');
  const images = mediums.filter((attachment) => attachment?.type === 'image');
  const documents = cards.filter(isDocumentAttachmentCard);

  counts.images = images.length;
  counts.videos = videos.length;
  counts.documents = documents.length;

  return counts;
};
